<template>
  <div v-if="rim">
    <h3> {{rim.manufacturer.name}} - {{rim.model}}</h3>
    <ul>
      <li v-if="rim.diameter > 0">Diameter: {{rim.diameter}} mm</li>
      <li v-if="rim.weight > 0">Weight: {{rim.weight}} g</li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'rim-display',
    props: ['rim'],
  }
</script>

<style scoped>
  img {
    width: 100%;
  }

  ul {
    list-style: none;
    text-align: left;
  }

  .rear-hub,
  .front-hub {
    position: relative;
  }

  .left-dia {
    position: absolute;
    top: 35%;
    left: 0;
  }

  .right-dia {
    position: absolute;
    top: 35%;
    right: 0;
  }

  .left2-center {
    position: absolute;
    left: 44%;
    bottom: 0;
  }

  .right2-center {
    position: absolute;
    left: 62%;
    bottom: 0;
  }

  .rear-hub .left2-center {
    left: 40%;
  }

  .rear-hub .right2-center {
    left: 55%;
  }
</style>



// WEBPACK FOOTER //
// src/components/rim-display.vue